import { useQuery } from '@tanstack/react-query';

import { fetchPlayerTiersRest } from '@/services/users/users-rest';

const useGetPlayerTiers = () => {
  const { data: playerTiers } = useQuery({
    queryKey: ['playerTiers'],
    queryFn: () => fetchPlayerTiersRest(),
    staleTime: 60000,
  });
  return { playerTiers };
};

export default useGetPlayerTiers;
